//------------------------------------------------------------------------------
// 地図部品
//------------------------------------------------------------------------------
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import '@esri/calcite-components/dist/components/calcite-action-bar';
import { CalciteActionBar } from '@esri/calcite-components-react'
import { setMapConfig } from '@/reducks/setting';

/**
 * 地図アクションバー (開閉ボタン付き)
 */
export default function MapActionBar({
  slot, children,
  ...otherProps
}) {

  // 地図動作設定 - 開閉状態
  const mapConfig = useSelector((state) => state.setting.mapConfig);
  const dispatch = useDispatch();

  // 開閉ボタン処理 - 開閉状態をストアに保存
  const handleExpandActionBar = React.useCallback((e) => {
    dispatch(setMapConfig({
      expandAction: e.target.expanded,
    }));
  }, [mapConfig]);

  // レイアウト
  const vertical = mapConfig.vertical;
  const layout   = vertical ? 'vertical' : 'horizontal';

  // 横並び表示の場合は展開表示なし/開閉ボタン無効
  const expanded = vertical ? mapConfig.expandAction : false;
  const expandDisabled = !vertical;

  //
  // 描画
  //
  return (
    <CalciteActionBar
      slot={slot}
      scale="m"
      floating overflowActionsDisabled
      layout={layout}
      expanded={expanded}
      expandDisabled={expandDisabled}
      onCalciteActionBarToggle={handleExpandActionBar}
      {...otherProps}
    >
      {children}
    </CalciteActionBar>
  );
}

// プロパティ
MapActionBar.propTypes = {
  slot: PropTypes.string,      // スロット
  children: PropTypes.node,    // 子要素
};
